import React, { useState } from "react";

export default function Toggle({ orderTypeDefault, onOrderTypeSelect }) {
  const [orderTypeValue, setOrderTypeValue] = useState(orderTypeDefault);

  return (
    <div className="py-4 mr-6">
      <div className="relative xl:w-fit lg:w-[600px] md:w-[300px] w-[180px] lg:h-[98px] md:h-[60px] h-10 bg-boonsdarkbg rounded-full flex items-center overflow-hidden">
        {/* Sliding background */}
        <div
          className={`absolute top-0 left-0 right-0 w-1/2 lg:h-[98px] md:h-[60px] h-10 bg-boonsOrange rounded-full transition-transform duration-300 ease-in-out ${orderTypeValue === "takeaway" ? "xl:translate-x-[350px] lg:translate-x-[300px] md:translate-x-[150px] translate-x-[90px]" : "translate-x-0"
            }`}
        ></div>

        {/* Options - clickable areas */}
        <div
          className="relative flex-1 xl:w-[350px] lg:w-[300px] w-[180px] md:p-4 p-2 rounded-full text-center lg:text-[40px] md:text-[30px] text-[15px] font-outfit font-medium font-weight-500 text-white cursor-pointer z-10 whitespace-nowrap"
          onClick={() => {
            setOrderTypeValue("dinein");
            onOrderTypeSelect("dinein")
          }}
        >
          Dine-In
        </div>
        <div
          className="relative flex-1 xl:w-[350px] lg:w-[300px] w-[180px] md:p-4 p-2 rounded-full text-center lg:text-[40px] md:text-[30px] text-[15px] font-outfit font-medium font-weight-500 text-white cursor-pointer z-10 whitespace-nowrap"
          onClick={() => {
            setOrderTypeValue("takeaway");
            onOrderTypeSelect("takeaway")
          }}
        >
          Take-Out
        </div>
      </div>
    </div>
  );
}
